import { Entity, makeClone } from 'gossamer-unified';
import { InstitutionMember } from './InstitutionMember';
import { InstitutionGroupMember } from './InstitutionGroupMember';
import { InstitutionGroup } from './InstitutionGroup';
import { InstitutionGroupEvent } from './InstitutionGroupEvent';
import { TicketBooking } from './TicketBooking';

export interface InstitutionGroupBookingViewRow {
  institution_group_id: number;
  institution_member_id: number;
  title: string;
  color_code: string;
  event_id: number;
  user_id: string;
  institution_id: number;
  status: string;
}

const clone = makeClone();

export const InstitutionGroupBookingView: Entity<InstitutionGroupBookingViewRow> = {
  id: 'InstitutionGroupBookingView',
  title: 'Institution Group Booking View',
  service: 'main',
  rowLabel: (row: InstitutionGroupBookingViewRow) => [row.institution_group_id, row.institution_member_id].join(' / '),
  rowLabelDynamic: (row: InstitutionGroupBookingViewRow) =>
    `<lookup:InstitutionMember:${row.institution_member_id}> / <lookup:InstitutionGroup:${row.institution_group_id}>`,
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.institution_group_booking_view',
  },
  security: [
    {
      role: 'user',
      action: 'read',
      access: 'conditional',
      condition: "user_id = '{userId}'",
    },
    {
      role: 'admin',
      action: 'all',
      access: 'conditional',
      condition: 'institution_id = {adminInstitutionId}',
    },
    { role: 'staff', action: 'all', access: 'all' },
  ],
  defaultSort: [['institution_group_id', 'ASC']],
  defaultFilters: [{ fieldId: 'institution_group_id', operator: 'eq', value: '' }],
  fields: {
    institution_group_id: clone(InstitutionGroupMember.fields.institution_group_id),
    institution_member_id: clone(InstitutionGroupMember.fields.institution_member_id),
    title: clone(InstitutionGroup.fields.title),
    color_code: clone(InstitutionGroup.fields.color_code),
    event_id: clone(InstitutionGroupEvent.fields.institution_event_id),
    user_id: clone(InstitutionMember.fields.user_id),
    institution_id: clone(InstitutionMember.fields.institution_id),
    status: clone(TicketBooking.fields.status),
  },
};
